import InvalidRouteErrorPage from '../src/static/pages/errors/InvalidRouteErrorPage'

const NotFound = () => <InvalidRouteErrorPage />

export default NotFound
